/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiResponseEmployerNetwork } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface EmployerNetworkServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     */
    employerNetworkControllerGetAllNetworks0(extraHttpRequestParams?: any): Observable<Array<ApiResponseEmployerNetwork>>;

    /**
     * 
     * 
     */
    employerNetworkControllerGetAllNetworks1(extraHttpRequestParams?: any): Observable<Array<ApiResponseEmployerNetwork>>;

}
